<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent" v-if="media">
        <div class="close" v-on:click="close(false)"></div>
        <div class="modalTitle">
          <div class="label">Download {{ type }}</div>
          <h4>{{ media.filename }}</h4>
        </div>
        <form class="selectorCnt" v-on:submit.prevent="handleSubmit">
          <template v-if="1>2">
            <p class="dlInfo" v-if="langCode === 'en'">
              A link to download this publication will be sent to your email.
              Please make sure you input registered email address.
            </p>
            <p class="dlInfo" v-if="langCode === 'id'">
              Link untuk download publikasi ini akan dikirim melalui email.
              Mohon untuk masukan alamat email yang terdaftar.
            </p>
          </template>
          <div class="fieldGroup" :class="{hasError: form.name.error}">
            <label v-if="langCode === 'en'">Name</label>
            <label v-if="langCode === 'id'">Nama</label>
            <input type="text" class="field"
              :placeholder="langCode === 'en' ? 'Full name..' : 'Nama lengkap...'"
              v-model="form.name.model" v-on:input="form.name.error = null">
            <div class="fieldError" v-if="form.name.error">
              {{form.name.error}}
            </div>
          </div>
          <div class="fieldGroup" :class="{hasError: form.email.error}">
            <label v-if="langCode === 'en'">Email</label>
            <label v-if="langCode === 'id'">Email</label>
            <input type="email" class="field"
              :placeholder="langCode === 'en' ? 'Email address..' : 'Alamat email...'"
              v-model="form.email.model" v-on:input="form.email.error = null">
            <div class="fieldError" v-if="form.email.error">
              {{form.email.error}}
            </div>
          </div>
          <div class="fieldGroup" :class="{hasError: form.org.error}">
            <label v-if="langCode === 'en'">Institution/Organization/Industry</label>
            <label v-if="langCode === 'id'">Institusi/Organisasi/Industri</label>
            <input type="text" class="field"
              :placeholder="langCode === 'en' ? 'Institution/Organization/Industry..'
              : 'Institusi/Organisasi/Industri...'"
              v-model="form.org.model" v-on:input="form.org.error = null">
            <div class="fieldError" v-if="form.org.error">
              {{form.org.error}}
            </div>
          </div>
          <button type="submit" class="btn" :class="{btnLoading: loading}">
            <span>
              <!-- Submit -->
              Download
            </span>
          </button>
        </form>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'shareDialog',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      item: null,
      media: null,
      type: null,
      detail: null,
      form: {
        name: { model: '', error: null },
        email: { model: '', error: null },
        org: { model: '', error: null },
      },
      loading: false,

      /**
       * Language
       *
       */
      loadingLang: true,
      langCode: 'id',
      lang: null,
    };
  },
  methods: {
    open(d, next) {
      this.detail = d.detail;
      this.item = d.item;
      this.media = d.media;
      this.type = d.type;
      this.loading = false;
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
    handleSubmit() {
      const formData = {
        name: this.form.name.model,
        email: this.form.email.model,
        org: this.form.org.model,
      };
      if (!formData.name) {
        this.form.name.error = this.langCode === 'id'
          ? 'Mohon isi nama lengkap'
          : 'Please fill your full name';
        return;
      }
      if (!formData.email) {
        this.form.email.error = this.langCode === 'id'
          ? 'Mohon isi alamat email'
          : 'Please fill your email address';
        return;
      }
      if (!formData.org) {
        this.form.org.error = this.langCode === 'id'
          ? 'Mohon isi institusi / organisasi / industri'
          : 'Please fill your institution / organization / industry';
        return;
      }
      this.loading = true;
      formData.lang = this.langCode;
      formData.mediaId = this.media.id;
      formData.data = this.item;
      formData.contentId = this.detail.id;
      formData.contentUrl = window.location.href;
      formData.fileUrl = this.media.uri;
      this.$http.post(this.$config.uri('misc/download'), formData).then(() => {
        this.close(true);
      });
    },
  },
  mounted() {
    this.langCode = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    // if (!this.langCode) this.langCode = window.navigator.userLanguage || window.navigator.language;
    // if (this.langCode === 'en-US' || this.langCode === 'en') this.langCode = 'en';
    // else if (this.langCode === 'id-ID' || this.langCode === 'id') this.langCode = 'id';
    // else this.langCode = 'en';
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px 30px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      width: 480px;
      max-width: 100%;
      @media (max-width: 680px) {
        width: calc(100% - 20px);
      }
      .close{
        position: absolute;
        right: 6px; top: 6px;
        width: 40px; height: 40px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #e9e9e9;
          opacity: .8;
        }
      }
      .modalTitle{
        padding: 24px 50px 14px;
        padding-left: 96px;
        border-bottom: #e5e5e5 1px solid;
        background-color: #f5f5fe;
        margin: -30px -40px 20px;
        font-weight: 400;
        text-align: left;
        &:before{
          content: "";
          position: absolute;
          left: 40px; top: 24px;
          width: 40px; height: 40px;
          background-image: url(../assets/pdf.svg);
          background-size: 40px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        .label{
          font-size: 15px;
          color: #767676;
        }
        h4{
          font-weight: 500;
          font-size: 17px;
          margin: 0;
        }
      }
      .selectorCnt{
        button.btn{
          width: 100%;
          margin-top: 10px;
          padding: 0;
          height: 46px;
        }
      }
    }
  }
</style>
